﻿import $ from "jquery";
import { showMessage, initTinymce } from "./main";
import bootbox from 'bootbox';

$(() => {
    var currentPage = $("#currentPage").val();
    if (currentPage != "headlineDetail") return;

    initTinymce('Description', 300);
    initShowFileSelectModal();
    initUploadFile();
    initDeleteFile();
});


function initShowFileSelectModal() {

    $("#selectFile").off('click');
    $('#selectFile').on('click', function () {
        $('#uploadFileModal').modal('show');
    });
}

function initUploadFile() {
    $('#uploadFile').on('click', function () {

        let fileInput = $('#fileForDownload')[0] as HTMLInputElement;
        let file = fileInput.files[0];

        let id = $('#Id').val();
        let languageCode = $('#LanguageCode').val();

        if (file) {
            let formData = new FormData();
            formData.append("image", file);
            formData.append("id", id.toString());
            formData.append("languageCode", languageCode.toString());

            $.ajax({
                url: '/Headline/UploadImage',
                type: 'POST',                
                data: formData,
                processData: false,
                contentType: false,
                success: function (response) {
                    $('#uploadFileModal').modal('hide');
                    $('#ImageFileName').val(response.fileName);
                    $('#OriginalImageFileName').val(response.originalImageFileName);
                    $('#ImageUrl').val(response.imageUrl);
                    $('#imgImageUrl').attr('src', response.imageUrl);
                },
                error: function (xhr) {
                    let msg = xhr?.responseJSON?.message || "Chyba pri nahrávaní súboru.";
                    showMessage(msg, "Chyba!");                
                }
            });
        } else {
            showMessage("Prosím, vyberte súbor.", "Chyba!");
        }
    });
}
function initDeleteFile() {
    $('#deleteFile').on('click', function () {

        let id = $('#Id').val();
        let languageCode = $('#LanguageCode').val();

        bootbox.confirm('Naozaj chcete zmazať fotku?',
            function (result) {
                if (result == true) {
                    let formData = new FormData();
                    formData.append("id", id.toString());
                    formData.append("languageCode", languageCode.toString());

                    $.ajax({
                        url: '/Headline/DeleteImage',
                        type: 'POST',
                        data: formData,
                        processData: false,
                        contentType: false,
                        success: function (response) {
                            $('#uploadFileModal').modal('hide');
                            $('#ImageFileName').val(response.fileName);
                            $('#OriginalImageFileName').val(response.originalImageFileName);
                            $('#ImageUrl').val(response.imageUrl);
                            $('#imgImageUrl').attr('src', response.imageUrl);
                        },
                        error: function () {
                            showMessage("Chyba pri mazaní súboru.", "Chyba!");
                        }
                    });    
                }
            });


    });
}
